<template>
  <iframe :src="src" allow="fullscreen" class="modal__youtube" />
</template>

<script>
export default {
  name: 'YoutubeEmbed',
  props: {
    youtubeId: { type: String, required: true },
  },
  computed: {
    src() {
      const link = new URL(`https://www.youtube.com/embed/${this.youtubeId}`)

      return link.toString()
    },
  },
}
</script>
